var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4985 9.83252L10.0026 5.49096",
    stroke: "black",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25592 16.3087L8.25512 16.9337C8.4253 16.9339 8.58821 16.8647 8.70623 16.7421L8.25592 16.3087ZM3.75278 11.9746L3.30247 11.5412C3.18445 11.6638 3.12154 11.8293 3.12827 11.9993L3.75278 11.9746ZM3.92399 16.3032L3.29948 16.3279L3.32319 16.9274L3.92319 16.9282L3.92399 16.3032ZM12.2412 4.3568L15.5435 7.53513L16.4103 6.63451L13.108 3.45618L12.2412 4.3568ZM15.5492 7.82971L7.8056 15.8753L8.70623 16.7421L16.4498 8.69652L15.5492 7.82971ZM4.20309 12.408L11.9467 4.36244L11.046 3.49562L3.30247 11.5412L4.20309 12.408ZM8.25671 15.6837L3.92479 15.6782L3.92319 16.9282L8.25512 16.9337L8.25671 15.6837ZM4.5485 16.2785L4.37729 11.9499L3.12827 11.9993L3.29948 16.3279L4.5485 16.2785ZM15.5435 7.53513C15.6264 7.61492 15.629 7.74681 15.5492 7.82971L16.4498 8.69652C17.0083 8.11622 16.9906 7.19302 16.4103 6.63451L15.5435 7.53513ZM13.108 3.45618C12.5277 2.89766 11.6045 2.91532 11.046 3.49562L11.9467 4.36244C12.0264 4.27954 12.1583 4.27702 12.2412 4.3568L13.108 3.45618Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 16.333H10.8332",
    stroke: "black",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.3b6f2238f62e1c0ff97437442b455ad4.svg";
export { ForwardRef as ReactComponent };